import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import { resetOnLogout } from '~/reducers/common-actions';
import type { RootState } from '~/store';
import type { MapPopupState } from './types';

export const mapPopupSlice = createSlice({
    name: 'mapPopup',
    initialState: null as MapPopupState,
    reducers: {
        addMapPopup: (
            state: MapPopupState,
            action: PayloadAction<MapPopupState>
        ): MapPopupState => {
            state = action.payload;
            return state;
        },
        removeMapPopup: (): MapPopupState => {
            return null;
        }
    },
    extraReducers: (builder) => {
        builder.addCase(resetOnLogout, () => {
            return null;
        });
    }
});

export const { addMapPopup, removeMapPopup } = mapPopupSlice.actions;

export const selectMapPopup = (state: RootState): MapPopupState =>
    state.mapPopup;

export default mapPopupSlice.reducer;
